import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0b343dee&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0b343dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b343dee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b343dee')) {
      api.createRecord('0b343dee', component.options)
    } else {
      api.reload('0b343dee', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0b343dee&scoped=true&", function () {
      api.rerender('0b343dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21G3p08TE0kFc/JS/comp/PopupBox.vue"
export default component.exports